import type { ComponentChildren, FunctionalComponent } from 'preact';

import { cnBubble } from '../bubble.constants.js';

import './bubble__content.css';

import './_tail-horizontal-position/bubble__content_tail-horizontal-position.css';
import './_tail-vertical-position/bubble__content_tail-vertical-position.css';

export interface BubbleContentProps {
    children: ComponentChildren;
    tailHorizontalPosition: 'left' | 'right';
    tailVerticalPosition: 'top' | 'bottom';
}

export const BubbleContent: FunctionalComponent<BubbleContentProps> = ({
    children,
    tailHorizontalPosition,
    tailVerticalPosition,
}) => (
    <div
        className={cnBubble('content', {
            'tail-horizontal-position': tailHorizontalPosition,
            'tail-vertical-position': tailVerticalPosition,
        })}
    >
        {children}
    </div>
);
